import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { text } from 'polyglot/polyglot';

import useCurrentGameStore from 'stores/current-game';
import useCountdownStore from 'stores/countdown-state';
import bingoAssetsStore from 'stores/bingoAssetsStore';
import useUpcomingGameStore from 'stores/upcoming-game';

import SmallerBanner from './SmallerBanner/SmallerBanner';
import LargerBanner from './LargerBanner/LargerBanner';
import NakedBanner from './NakedBanner/NakedBanner';

const currentGameSelector = (state) => state.currentGame;
const hourSelector = (state) => state.hours;
const minutesSelector = (state) => state.minutes;
const secondsSelector = (state) => state.seconds;
const startOfGameSelector = (state) => state.startOfGame;
const activeCountdownGameSelector = (state) => state.activeCountdownGame;
const fetchGameAssetsSelector = (state) => state.fetchGameAssets;
const nextGameSelector = (state) => state.nextGame;
function UpcomingGameBanner({
  largeBanner,
  nakedBanner,
  hideInfoButton,
  game,
  timeToStart,
}) {
  const currentGame = useCurrentGameStore(currentGameSelector);
  const hours = useCountdownStore(hourSelector);
  const minutes = useCountdownStore(minutesSelector);
  const seconds = useCountdownStore(secondsSelector);
  const startOfGame = useCountdownStore(startOfGameSelector);
  const activeCountdownGame = useCountdownStore(activeCountdownGameSelector);
  const fetchGameAssets = bingoAssetsStore(fetchGameAssetsSelector);
  const nextGame = useUpcomingGameStore(nextGameSelector);

  const getCountdownParts = (time) => {
    if (!time) return { hours: '00', minutes: '00', seconds: '00' };
    const now = new Date();
    const start = new Date(time);
    let diff = Math.max(0, Math.floor((start - now) / 1000));
    const hoursFromProp = Math.floor(diff / 3600);
    diff %= 3600;
    const minutesFromProp = Math.floor(diff / 60);
    const secondsFromProp = diff % 60;
    return {
      hoursFromProp: hoursFromProp.toString().padStart(2, '0'),
      minutesFromProp: minutesFromProp.toString().padStart(2, '0'),
      secondsFromProp: secondsFromProp.toString().padStart(2, '0'),
    };
  };

  const gameAssets = bingoAssetsStore((state) =>
    activeCountdownGame ? state.getGameAssets(activeCountdownGame) : {}
  );

  const nextGameAssets = bingoAssetsStore((state) =>
    nextGame ? state.getGameAssets(nextGame) : {}
  );

  const upcomingGameAssets = bingoAssetsStore((state) =>
    activeCountdownGame ? state.getGameAssets(game) : {}
  );

  useEffect(() => {
    if (nextGame) {
      fetchGameAssets(nextGame);
    }
  }, [nextGame, fetchGameAssets]);

  useEffect(() => {
    if (activeCountdownGame) {
      fetchGameAssets(activeCountdownGame);
    }
  }, [activeCountdownGame, fetchGameAssets]);

  useEffect(() => {
    if (game) {
      fetchGameAssets(game);
    }
  }, [game, fetchGameAssets]);

  if (game && timeToStart) {
    const { hoursFromProp, minutesFromProp, secondsFromProp } =
      getCountdownParts(timeToStart);
    if (
      largeBanner &&
      upcomingGameAssets.backgroundSmall &&
      upcomingGameAssets.logoSmall &&
      upcomingGameAssets.logoBig
    ) {
      return (
        <LargerBanner
          hideInfoButton={hideInfoButton}
          background={upcomingGameAssets.backgroundSmall}
          logoSmall={upcomingGameAssets.logoSmall}
          logoBig={upcomingGameAssets.logoBig}
          text={text.t('gameBanner.largeBannerTitleBuy')}
          hours={hoursFromProp}
          minutes={minutesFromProp}
          seconds={secondsFromProp}
        />
      );
    }
    if (nakedBanner) {
      return (
        <NakedBanner
          name={game.name}
          minutes={minutesFromProp}
          seconds={secondsFromProp}
        />
      );
    }
    if (upcomingGameAssets.backgroundSmall && upcomingGameAssets.logoSmall) {
      return (
        <SmallerBanner
          background={upcomingGameAssets.backgroundSmall}
          logoSmall={upcomingGameAssets.logoSmall}
          minutes={minutesFromProp}
          seconds={secondsFromProp}
          gameId={game.bingoRoundId || 0}
        />
      );
    }
  }

  if (largeBanner && !game && !timeToStart) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {startOfGame &&
          hours &&
          minutes &&
          seconds &&
          gameAssets.backgroundSmall &&
          gameAssets.logoSmall &&
          gameAssets.logoBig && (
            <LargerBanner
              hideInfoButton={hideInfoButton}
              background={gameAssets.backgroundSmall}
              logoSmall={gameAssets.logoSmall}
              logoBig={gameAssets.logoBig}
              text={
                currentGame.isDrawing
                  ? text.t('gameBanner.largeBannerTitlePrebuy')
                  : text.t('gameBanner.largeBannerTitleBuy')
              }
              hours={hours}
              minutes={minutes}
              seconds={seconds}
            />
          )}
      </>
    );
  }
  if (nakedBanner && !game && !timeToStart) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {startOfGame && minutes && seconds && (
          <NakedBanner
            name={
              activeCountdownGame && activeCountdownGame.name
                ? activeCountdownGame.name
                : ''
            }
            minutes={minutes}
            seconds={seconds}
          />
        )}
      </>
    );
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {startOfGame &&
        minutes &&
        seconds &&
        gameAssets.backgroundSmall &&
        gameAssets.logoSmall && (
          <SmallerBanner
            background={nextGameAssets.backgroundSmall}
            logoSmall={nextGameAssets.logoSmall}
            minutes={minutes}
            seconds={seconds}
            gameId={currentGame.bingoRoundId || 0}
          />
        )}
    </>
  );
}

UpcomingGameBanner.propTypes = {
  largeBanner: PropTypes.bool,
  nakedBanner: PropTypes.bool,
  hideInfoButton: PropTypes.bool,
  game: PropTypes.shape({
    id: PropTypes.number,
    bingoRoundId: PropTypes.number,
    bingoLayoutName: PropTypes.string,
    bingoLayoutCode: PropTypes.string,
    bingoLayoutImageData: PropTypes.string,
    name: PropTypes.string,
    cardPrice: PropTypes.number,
    jackpotAmount: PropTypes.number,
    jackpotValueDisplayName: PropTypes.string,
    status: PropTypes.string,
    logoBig: PropTypes.string,
    logoSmall: PropTypes.string,
    backgroundBig: PropTypes.string,
    backgroundSmall: PropTypes.string,
    potBoosterActive: PropTypes.bool,
    ballsPerCoordinate: PropTypes.number,
    fixedPotSize: PropTypes.number,
    minimumPotSize: PropTypes.number,
  }),
  timeToStart: PropTypes.string,
};

UpcomingGameBanner.defaultProps = {
  largeBanner: false,
  nakedBanner: false,
  hideInfoButton: false,
  game: null,
  timeToStart: null,
};

export default UpcomingGameBanner;
